module.exports = __webpack_public_path__ + "img/ke.5d45eaae.svg";